export default {
  label: {
    commandUrl: 'Url para enviar comandos',
    botKey: 'Chave do Bot',
  },
  button: {
    save: 'Salvar informações',
  },
  message: {
    success: 'Contrato salvo com sucesso',
    error: 'Erro ao salvar informações de contrato',
  },
};
